import { NgModule } from '@angular/core';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { CartBaseCoreModule } from '@spartacus/cart/base/core';
import {
  // CartPageLayoutHandler,
  PAGE_LAYOUT_HANDLER,
} from '@spartacus/storefront';
import { MiniCartModule } from '../header/mini-cart/mini-cart.module';
import { AddToCartModule } from './add-to-cart/add-to-cart.module';
import { CartDetailsModule } from './cart-details/cart-details.module';
import { CartPageLayoutHandler } from './cart-page-layout-handler';
import { CartSharedModule } from './cart-shared/cart-shared.module';
import { CartTotalsModule } from './cart-totals/cart-totals.module';
import { SavedCartDetailsModule } from './saved-cart-details/saved-cart-details.module';
import { SavedCartsListModule } from './saved-carts-list/saved-carts-list.module';

@NgModule({
  imports: [NgbModule, CartDetailsModule, CartTotalsModule, CartSharedModule],
  exports: [
    CartDetailsModule,
    CartTotalsModule,
    CartSharedModule,
    AddToCartModule,
    MiniCartModule,
    CartBaseCoreModule,
    SavedCartsListModule,
    SavedCartDetailsModule,
  ],
  declarations: [],
  providers: [
    {
      provide: PAGE_LAYOUT_HANDLER,
      useExisting: CartPageLayoutHandler,
      multi: true,
    },
  ],
})
export class CartComponentModule {}
